'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = checkout;

var _immutable = require('immutable');

var _CreationActionTypes = require('../actionTypes/CreationActionTypes');

var initialState = new _immutable.Map({
  redirectUrl: null
});

function checkout() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _CreationActionTypes.CREATION_SUCCEEDED:
      return state.merge({
        redirectUrl: payload.redirectUrl
      });
    case _CreationActionTypes.CREATION_FAILED:
    case _CreationActionTypes.CREATION_ATTEMPTED:
      return state.merge({
        redirectUrl: null
      });

    default:
      return state;
  }
}
module.exports = exports['default'];